export const loader = {
    show: function () {
        const element = document.querySelector('.ajax-loader');
        element.setAttribute('display-time', 1);
        element.style.display = 'block';
    },
    hide: function () {
        const element = document.querySelector('.ajax-loader');
        element.removeAttribute('display-time');
        element.style.display = 'none';
    }
};
